import React, { useEffect, useState } from "react";
import "./About.scss";
import { styled } from "@mui/material/styles";
import { Box, Button, Link, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import { detectIncognito } from "detectincognitojs";
import { vendor_software_version, folURL } from "../../constants/default_request";
import Vessel from "../../assets/icon.png";
import { resetCache } from "../../actions/reset_cache";
import { useDispatch, useSelector } from "react-redux";
import { getBrowsersInfo, storageCheck } from "../../enhancers/utils";
import { usePwaStatus } from "../../components/CustomHooks/usePwaStatus";

const About = ({ showAbout, hideAbout }) => {
  const client_id = useSelector((state) => state.auth.client_id);
  const dispatch = useDispatch();
  const [data, setData] = useState("N/A");
  const [isIncognito, setIsIncognito] = useState(false);
  const { isPwaInstalled, persistence } = usePwaStatus();

  const styles = {
    textStyle: {
      fontFamily: "Arial Narrow",
    },
    imgStyle: {
      width: "25%",
      height: "25%",
    },
    info: {
      primary: "#0A4595",
      secondary: "#f50057",
    },
  };
  const { browser, os } = getBrowsersInfo();
  const email = "nmfs.gar.reporting@noaa.gov";

  useEffect(() => {
    const getData = async () => {
      try {
        const { details } = await storageCheck();
        setData(details);
      } catch (error) {
        const message = `Cannot obtain storage info: ${error}`;
        console.error(message);
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const getMode = async () => {
      const browser = await detectIncognito();
      setIsIncognito(browser.isPrivate ? "Session" : "Persistent");
    };
    getMode();
  }, []);

  return (
    <Dialog open={showAbout} style={styles.textStyle}>
      <Box m={2} align="center">
        <h2 className="sectionTitle center">About</h2>
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
          <Grid item sm={6}>
            <img src={Vessel} style={styles.imgStyle} alt="N O A A dot gov logo" />
          </Grid>
          <Grid item xs={12}>
            <h3>NOAA Fisheries Online</h3>
            <div>{"Version " + vendor_software_version()}</div>
          </Grid>
          <Grid item xs={12}>
            <p>
              For general questions about vessel trip reporting, call (978) 281-9188 or
              email us at &nbsp;
              <a href={`mailto:${email}`}>nmfs.gar.reporting@noaa.gov.</a>
              &nbsp;Additional information can be found on our &nbsp;
              <Link
                aria-label="Read more about Vessel Trip Reporting"
                target="_blank"
                href={folURL}
              >
                website
              </Link>
              .
            </p>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <Item>Current Browser: {browser}</Item>
            </Grid>
            <Grid item xs={6}>
              <Item>Operative System: {os}</Item>
            </Grid>
            <Grid item xs={6}>
              <Item>
                Storage status: &nbsp;
                <span
                  style={{
                    color: persistence.persisted
                      ? styles.info.primary
                      : styles.info.secondary,
                  }}
                >
                  {isIncognito}
                </span>
              </Item>
            </Grid>
            <Grid item xs={6}>
              <Item>
                PWA status: &nbsp;
                <span
                  style={{
                    color: isPwaInstalled ? styles.info.primary : styles.info.secondary,
                  }}
                >
                  {isPwaInstalled ? "App is Installed!" : "Running in Browser"}
                </span>
              </Item>
            </Grid>
            <Grid item xs={12}>
              <Item>Browser's storage information: {data}</Item>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={() => dispatch(resetCache(client_id))}
              style={{ backgroundColor: "#5499C7" }}
            >
              Clear Cache
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button onClick={hideAbout} style={{ backgroundColor: "#5499C7" }}>
              Close
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default About;
